import reallocateEmissionsReducer from './reallocateEmissions';

export default {
  reallocateEmissions: reallocateEmissionsReducer
};
